import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.232.768a2.5 2.5 0 0 1 3.536 0l7.464 7.464a2.5 2.5 0 0 1 0 3.536l-7.464 7.464a2.5 2.5 0 0 1-3.536 0L.768 11.768a2.5 2.5 0 0 1 0-3.536L8.232.768zm.733 5.196a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
});

var SvgCircleDisabledMajorFilled = function SvgCircleDisabledMajorFilled(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCircleDisabledMajorFilled as S };
